import React from 'react';
import {connect} from "react-redux";
import {
    Spacer,
    Text,
    getMessage
} from '../../components';
import SUPPORT_DATA from '../../constants/SupportConstants';
import PropTypes from "prop-types";

const mapStateToProps = state => {
    return {
        messages: state.get('localization').get('messageProperties'),
        locale: state.get('localization').get('locale')
    };
};

const SupportView = ({
                         messages,
                         locale
    }) => {
    const {
        supportTiles,
        title
    } = SUPPORT_DATA;
    return (
        <div className="container support__root" id="content">
            <h1 className="support__title">{getMessage(messages, title)}</h1>
            <Spacer className="row" top={32}>
                {supportTiles.supportTileList.map(tile => {
                    return (
                        <div className="col-xs-12 col-md-6" key={tile.logo}>
                            <a href={`${tile.url}?lang=${locale}`}>
                                <img className="support__img" src={tile.image} alt={tile.title} />
                                <Text as="div" className="support__tilename" top={16} bottom={32}>{tile.title}</Text>
                            </a>
                        </div>
                    );
                })}
            </Spacer>
        </div>
    );
};

SupportView.propTypes = {
    messages: PropTypes.object,
    locale: PropTypes.object
};

export default connect(mapStateToProps)(React.memo(SupportView));
